import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Toast from "react-bootstrap/Toast";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { closeClientModal, modalSelector } from "../../redux/modalSlice";
import { useDispatch } from "react-redux";
import {
  closeNotification,
  notificationSelector,
} from "../../redux/notificationSlice";
const Toaster = ({ show }) => {
  const { notification } = useSelector(notificationSelector);
  const dispatch = useDispatch();

  return (
    <>
      {/* <Button onClick={() => setShowToaster(true)}>Show Toast</Button> */}
      <Toast
        onClose={() => dispatch(closeNotification())}
        show={notification.show}
        delay={5000}
        autohide
        className="toaster toasrerSuccess"
      >
        <div className="media-toaster">
          <div className="icon" onClick={() => dispatch(closeNotification())}>
            <Icon icon="charm:tick" />
          </div>
          <div className="toaster-body">
            <ul>
              <li>
                <span>WH&E</span>
              </li>
              <li>
                <span className="time">Just now</span>
              </li>
            </ul>
            <p>{notification.message}</p>
            {notification.link && (
              <Link to="#" className="cta-link">
                Click this toast to view the survey created
              </Link>
            )}
          </div>

          <Toast.Header></Toast.Header>
        </div>
      </Toast>
    </>
  );
};

export default Toaster;
